<template>
  <div class="section-box">
    <el-tabs v-model="seaType" type="card" class="customer-tabs-mg">
      <el-tab-pane v-for="(item, index) in titleCourse" :label="item.value" :name="item.key + ''" :key="index">
      </el-tab-pane>
    </el-tabs>
    
    <Certuficatp v-if="seaType==1"/>
    <Certuficate v-if="seaType==2"/>
  </div>
</template>
<script>
  import Certuficatp from './index/certuficatp'
  import Certuficate from './index/certuficate'
  export default {
    components: {
        Certuficatp,
        Certuficate
    },
    data() {
      return {
        seaType: '1',
        titleCourse: [],
        form: {

        },
        searchData: {},
        oraginForm: {},
        total: 0, //总条数

        tableData: [],
      };
    },
    created() {
      this.oraginForm = JSON.parse(JSON.stringify(this.form));
      this.tableData = [];
      this.getTitle();
    },
    methods: {
      getTitle() {
        this.titleCourse = [
            {
                key: 1,
                value: "个人",
            },
            {
                key: 2,
                value: "企业",
            }, 
        ];
      },
    },
  };
</script>
<style lang="scss">
  .customer-tabs-mg {
    .el-tabs__header {
      margin: 0 0 15px !important;
    }
  }

  .customer-list {
    position: relative;

    .next-button {
      position: absolute;
      right: 0;
      top: -56px;
    }
  }

  .customer-row-bg {
    padding: 20px 14px;
    background-color: #f9fafc;
    display: flex;
    align-items: center;

    .el-form-item {
      margin-bottom: 0 !important;
    }

    .selected {
      color: #409eff;
      border-color: #c6e2ff;
      background-color: #ecf5ff;
    }
  }

  .linkInfo {
    cursor: pointer;

    &:hover {
      color: #409eff;
    }
  }
</style>